<template>
  <div id="document-list-view">
    <div class="list-header px-4 py-2 flex flex-wrap justify-between text-sm">
      <div class="list-item-checkbox flex">
        <vs-checkbox
          v-model="isAllSelected"
          :color="AISEA_COLOR.BLUE"
        ></vs-checkbox>
      </div>
      <div
        class="list-item-filename flex px-4 w-10/12"
        :class="showFilePath ? 'md:w-4/12' : 'md:w-6/12'"
      >
        <div
          class="flex items-center cursor-pointer"
          @click="toggleSort('name')"
        >
          <span class="mr-2">ファイル名</span>
          <feather-icon
            svgClasses="h-4 w-4"
            v-show="isSortTarget('name')"
            :icon="sortIcon"
          />
        </div>
      </div>
      <div
        v-show="showFilePath"
        class="list-item-size flex items-center px-4 hidden md:flex md:w-2/12"
      >
        <div
          class="flex items-center cursor-pointer"
          @click="toggleSort('path')"
        >
          <span class="flex items-center">場所</span>
          <feather-icon
            svgClasses="h-4 w-4"
            v-show="isSortTarget('path')"
            :icon="sortIcon"
          />
        </div>
      </div>
      <div
        class="list-item-size flex items-center px-4 hidden md:flex md:w-2/12"
      >
        <div
          class="flex items-center cursor-pointer"
          @click="toggleSort('size')"
        >
          <span class="flex items-center">サイズ</span>
          <feather-icon
            svgClasses="h-4 w-4"
            v-show="isSortTarget('size')"
            :icon="sortIcon"
          />
        </div>
      </div>
      <div
        class="list-item-updated flex items-center px-4 hidden md:flex md:w-1/5"
      >
        <div
          class="flex items-center cursor-pointer"
          @click="toggleSort('updated')"
        >
          <span class="flex items-center">最終更新時間</span>
          <feather-icon
            svgClasses="h-4 w-4"
            v-show="isSortTarget('updated')"
            :icon="sortIcon"
          />
        </div>
      </div>
      <div class="list-item-action justify-end p-3"></div>
    </div>
    <div
      v-if="fileNotExists"
      id="file-not-exists"
      class="flex m-4 px-4 py-2 align-middle"
    >
      <span>ファイルがありません</span>
    </div>
    <div v-else>
      <VuePerfectScrollbar
        :style="{ maxHeight: scrollHeight }"
        :settings="scrollbarSettings"
      >
        <!-- フォルダ -->
        <div>
          <div v-show="showFolder">
            <div
              v-for="(document, index) in displayDocuments.folders"
              :key="'list_folder' + index"
            >
              <card :document="document" :isFolder="true"></card>
            </div>
          </div>

          <!-- ファイル -->
          <div
            v-for="(document, index) in displayDocuments.files"
            :key="'list_file' + index"
          >
            <card :document="document" :isFolder="false"></card>
          </div>
        </div>
      </VuePerfectScrollbar>
    </div>
  </div>
</template>

<script>
import { ColorMixin, DocumentMixin } from "@/mixins";
import Card from "./DocumentContentListCard"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { createNamespacedHelpers } from "vuex";

const {
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager,
  mapActions: mapActionsOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");


export default {
  mixins: [ColorMixin, DocumentMixin],
  components: {
    Card,
    VuePerfectScrollbar
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "displayDocuments",
      "isSelectedAllFile",
      "isSearching",
      "showListCardPath",
      "showFolderList",
      "isSortOrderAsc",
      "sortKey"
    ]),
    scrollHeight () {
      return `${this.$store.state.windowHeight - 340}px`
    },
    isAllSelected: {
      get () { return this.isSelectedAllFile },
      set (selected) {
        selected ?
          this.SET_ALL_DOCUMENTS_SELECTED() :
          this.RESET_SELECTED_DOCUMENTS();
      }
    },
    fileNotExists () {
      if (!this.displayDocuments) return true
      return this.displayDocuments.files.length === 0 && this.displayDocuments.folders.length === 0
    },
    showFilePath () {
      return this.isSearching || this.showListCardPath
    },
    showFolder () {
      return this.showFolderList
    },
    sortIcon () {
      return this.isAsc ? "ArrowUpIcon" : "ArrowDownIcon";
    },
    isAsc: {
      get(){ 
        return this.isSortOrderAsc; 
      },
      set(val) {
        this.SET_IS_SORT_ORDER_ASC(val);
      }
    },
    sortTargetKey: {
      get(){ 
        return this.sortKey; 
      },
      set(val) {
        this.SET_SORT_KEY(val);
      }
    }
  },
  methods: {
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_ALL_DOCUMENTS_SELECTED",
      "RESET_SELECTED_DOCUMENTS",
      "SET_SORT_KEY",
      "SET_IS_SORT_ORDER_ASC"
    ]),
    ...mapActionsOfenterpriseDocumentManager(["sortDocument"]),
    toggleSort(target){
      this.sortTargetKey = target;
      this.isAsc = !this.isAsc;
      const payload = {
        key: target,
        isAsc: this.isAsc
      };
      this.sortDocument(payload);
    },
    isSortTarget (target) {
      return target === this.sortTargetKey;
    },

  }
}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

#document-list-view {
  .list-header {
    border: 1px solid #0000;
  }

  .scroll-area {
    height: 52vh;
  }

  #file-not-exists {
    color: $aisea-gray;
  }
}
</style>